<template>
  <!-- 文章分类 -->
  <div class="articleSort">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['文章管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="handleAdd(false)"
          >新增分类</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">分类状态：</label>
        <el-select
          v-model="searchForm.status"
          placeholder="分类状态"
          style="width: 100px; margin-right: 5px"
        >
          <el-option label="全部" value="9"></el-option>
          <el-option label="已启用" value="2"></el-option>
          <el-option label="已禁用" value="1"></el-option>
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="handleRefresh"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 90px)"
      :row-style="{ color: '#303133' }"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      style="width: 100%"
      @expand-change="expandTable"
      :expand-row-keys="expandList"
      row-key="id"
    >
      <el-table-column label="序号" align="center" type="index" width="150">
      </el-table-column>
      <el-table-column type="expand" label="展开" align="center" width="50">
        <template slot-scope="props">
          <el-table
            :data="props.row.childs"
            stripe
            border
            tooltip-effect="dark"
            style="width: 100%"
            @expand-change="expandTableTwo"
            :expand-row-keys="expandTwoList"
            row-key="id"
          >
            <el-table-column label="序号" align="center" width="100">
              <template slot-scope="scope">
                <span>{{ props.$index + 1 }}-{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              type="expand"
              label="展开"
              align="center"
              width="50"
            >
              <template slot-scope="item">
                <el-table
                  :data="item.row.childs"
                  stripe
                  border
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <el-table-column label="序号" align="center" width="100">
                    <template slot-scope="scope">
                      <span
                        >{{ props.$index + 1 }}-{{ item.$index + 1 }}-{{
                          scope.$index + 1
                        }}</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="id"
                    align="center"
                    show-overflow-tooltip
                    label="类别编号"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="title"
                    align="center"
                    show-overflow-tooltip
                    label="类别名称"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="rank"
                    label="等级"
                    align="center"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="sort"
                    label="排序"
                    align="center"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="status"
                    label="状态"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-tag type="warning" v-if="scope.row.status == 1"
                        >已禁用</el-tag
                      >
                      <el-tag type="success" v-if="scope.row.status == 2"
                        >已启用</el-tag
                      >
                      <el-tag type="info" v-if="scope.row.status == 0"
                        >已删除</el-tag
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                      <el-button
                        v-show="scope.row.status != 0"
                        type="primary"
                        style="padding: 2px 3px"
                        plain
                        @click="handleAdd(scope.row)"
                        >编辑</el-button
                      >
                      <el-button
                        v-show="scope.row.status == 1"
                        type="success"
                        style="padding: 2px 3px"
                        plain
                        @click="handleStatus(scope.row, 2)"
                        >启用</el-button
                      >
                      <el-button
                        v-show="scope.row.status == 2"
                        type="warning"
                        style="padding: 2px 3px"
                        plain
                        @click="handleStatus(scope.row, 1)"
                        >禁用</el-button
                      >
                      <el-button
                        v-show="scope.row.status != 0"
                        type="danger"
                        style="padding: 2px 3px"
                        plain
                        @click="handleStatus(scope.row, 0)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
              prop="id"
              align="center"
              show-overflow-tooltip
              label="类别编号"
            >
            </el-table-column>
            <el-table-column
              prop="title"
              align="center"
              show-overflow-tooltip
              label="类别名称"
            >
            </el-table-column>
            <el-table-column
              prop="rank"
              label="等级"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="sort"
              label="排序"
              align="center"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="status"
              label="状态"
              align="center"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-tag type="warning" v-if="scope.row.status == 1"
                  >已禁用</el-tag
                >
                <el-tag type="success" v-if="scope.row.status == 2"
                  >已启用</el-tag
                >
                <el-tag type="info" v-if="scope.row.status == 0">已删除</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  v-show="scope.row.status != 0"
                  type="primary"
                  style="padding: 2px 3px"
                  plain
                  @click="handleAdd(scope.row)"
                  >编辑</el-button
                >
                <el-button
                  v-show="scope.row.status == 1"
                  type="success"
                  style="padding: 2px 3px"
                  plain
                  @click="handleStatus(scope.row, 2)"
                  >启用</el-button
                >
                <el-button
                  v-show="scope.row.status == 2"
                  type="warning"
                  style="padding: 2px 3px"
                  plain
                  @click="handleStatus(scope.row, 1)"
                  >禁用</el-button
                >
                <el-button
                  v-show="scope.row.status != 0"
                  type="danger"
                  style="padding: 2px 3px"
                  plain
                  @click="handleStatus(scope.row, 0)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column
        prop="id"
        align="center"
        show-overflow-tooltip
        label="类别编号"
      >
      </el-table-column>
      <el-table-column
        prop="title"
        align="center"
        show-overflow-tooltip
        label="类别名称"
      >
      </el-table-column>
      <el-table-column
        prop="rank"
        label="等级"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="sort"
        label="排序"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="warning" v-if="scope.row.status == 1">已禁用</el-tag>
          <el-tag type="success" v-if="scope.row.status == 2">已启用</el-tag>
          <el-tag type="info" v-if="scope.row.status == 0">已删除</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-show="scope.row.status != 0"
            type="primary"
            style="padding: 2px 3px"
            plain
            @click="handleAdd(scope.row)"
            >编辑</el-button
          >
          <el-button
            v-show="scope.row.status == 1"
            type="success"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 2)"
            >启用</el-button
          >
          <el-button
            v-show="scope.row.status == 2"
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 1)"
            >禁用</el-button
          >
          <el-button
            v-show="scope.row.status != 0"
            type="danger"
            style="padding: 2px 3px"
            plain
            @click="handleStatus(scope.row, 0)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
    <!-- 编辑分类 -->
    <el-drawer
      :visible.sync="addDrawer"
      :withHeader="false"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      :wrapperClosable="$store.state.closeOnClickModal"
      direction="rtl"
    >
      <div class="drawer-header">编辑分类</div>
      <el-scrollbar style="height: calc(100% - 90px)">
        <div class="drawer-form-wrap">
          <el-form
            :model="addForm"
            label-position="rigth"
            label-width="120px"
            :rules="addFormRule"
            ref="addForm"
          >
            <el-form-item label="选择级别" prop="rank">
              <el-select
                v-model="addForm.rank"
                placeholder="请选择"
                style="width: 100%"
                @change="setSortRank"
              >
                <el-option label="一级分类" value="1"></el-option>
                <el-option label="二级分类" value="2"></el-option>
                <el-option label="三级分类" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-show="addForm.rank == '2'"
              label="选择父级分类"
              prop="parentId"
            >
              <el-select
                v-model="addForm.parentId"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in tableData"
                  :key="index"
                  :label="item.title"
                  :value="item.id + ''"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-show="addForm.rank == '3'"
              label="选择父级分类"
              prop="parentId"
            >
              <el-select
                v-model="addForm.parentId"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in twoList"
                  :key="index"
                  :label="item.title"
                  :value="item.id + ''"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="分类名称" prop="title">
              <el-input v-model="addForm.title"></el-input>
            </el-form-item>
            <el-form-item label="分类图片" prop="icon">
              <upload
                @fileChange="uploadSortImg"
                accept="image/jpg,image/jpeg,image/png"
                :multiple="true"
              ></upload>
              <img-view
                style="margin-left: 20px"
                :imgList="[{ url: sortImg, id: 0 }]"
              ></img-view>
            </el-form-item>
            <el-form-item
              v-show="addForm.rank == '1'"
              label="跳转路径"
              prop="name"
            >
              <el-input v-model="addForm.name"></el-input>
            </el-form-item>
            <el-form-item label="排序" prop="sort">
              <el-input-number
                v-model="addForm.sort"
                style="width: 100%"
                :min="0"
              ></el-input-number>
            </el-form-item>
          </el-form>
        </div>
      </el-scrollbar>
      <div class="drawer-footer">
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button type="info" @click="clearForm">取消</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: "articleSort",
  data() {
    return {
      /**表格数据 */
      // {
      //   id: "分类ID",
      //   title:"类别名称",
      //   rank:"级别",
      //   sort:"排序",
      //   icon:"图片地址",
      //   childs:[]
      // }
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**select选中项 */
      selectedList: [],
      // 搜索项
      searchForm: {
        status: "9",
      },
      // 二级分类列表
      twoList: [],
      /**新增drawer */
      addDrawer: false,
      /**新增分类表单 */
      addForm: {
        id: 0,
        title: "",
        rank: "1",
        sort: 1,
        status: 2,
        channelId: 1,
        parentId: "0",
        name: "",
        icon: "",
        navType: "HomePage",
      },
      sortImg: "", // 分类图片，用于本地显示
      addFormRule: {
        rank: [mustFill],
        parentId: [mustFill],
        title: [mustFill],
        sort: [mustFill],
      },
      // 处理表格展开功能
      expandList: [],
      expandTwoList: [],
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    updata() {
      this.getTableData();
    },
    /**获取表格 */
    getTableData() {
      let data = {
        navType: "HomePage",
        status: this.searchForm.status,
      };
      this.$request({
        url: "Navigation/GetNavigationAll",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (res.success) {
            this.changeArr(res.list || []);
          } else {
            this.tableData = [];
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**递归调用函数 */
    changeArr(list) {
      let obj = {};
      obj[0] = [];
      let twoList = [];
      for (let i = 0; i < list.length; i++) {
        let item = list[i];
        let itemData = this.setTabelItem(item);
        if (item.rank == 1) {
          obj[0].push(itemData);
        } else {
          if (!obj[item.parent_id]) {
            obj[item.parent_id] = [];
          }
          if (item.rank == 2) {
            twoList.push(itemData);
          }
          obj[item.parent_id].push(itemData);
        }
      }
      for (let i = 0; i < obj[0].length; i++) {
        obj[0][i].childs = obj[obj[0][i].id];
        delete obj[obj[0][i].id];
      }
      for (let i = 0; i < twoList.length; i++) {
        twoList[i].childs = obj[twoList[i].id];
      }
      this.allPage = obj[0].length;
      this.tableData = obj[0];
      this.twoList = twoList;
    },
    // 设置表格数据格式
    setTabelItem(item) {
      return {
        id: item.Id,
        title: item.title,
        rank: item.rank + "",
        sort: item.sort_id,
        status: item.status,
        channelId: item.channel_id,
        parentId: item.parent_id + "",
        name: item.name,
        icon: item.icon_url,
        navType: item.nav_type,
        childs: [],
      };
    },

    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
    },

    /**客户 selection change触发事件 */
    selectionChange(section) {
      //存放选中的表格数据
      this.selectedList = section;
    },
    // 表格展开功能处理
    expandTable(row, list) {
      this.expandList = list.map((item) => item.id);
    },
    expandTableTwo(row, list) {
      this.expandTwoList = list.map((item) => item.id);
    },

    /**更改状态 */
    handleStatus(row, status) {
      let tips = "确定要启用吗？";
      let type = "success";
      if (status == 2) {
        tips = "确定要启用吗？";
        type = "success";
      } else if (status == 1) {
        tips = "确定要禁用吗？";
        type = "warning";
      } else if (status == 0) {
        tips = "确定要删除吗？";
        type = "error";
      }
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
      })
        .then(() => {
          let data = {
            id: row.id,
            status: status,
          };
          this.$request({
            url: "Navigation/UpdateNavigationStatusDal",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    /**新增/编辑分类 */
    handleAdd(row) {
      this.clearForm();
      if (row) {
        for (let key in this.addForm) {
          this.addForm[key] = row[key];
        }
        this.sortImg = this.$setImgUrl(row.icon);
      }
      this.addDrawer = true;
    },
    /**关闭drawer 清空表单信息 */
    clearForm() {
      this.addForm = {
        id: 0,
        title: "",
        rank: "1",
        sort: 1,
        status: 2,
        channelId: 1,
        parentId: "0",
        name: "",
        icon: "",
        navType: "HomePage",
      };
      this.sortImg = "";
      this.addDrawer = false;
    },
    // 设置分类等级
    setSortRank() {
      if (this.addForm.rank == 2) {
        this.addForm.parentId = this.tableData[0].id + "";
      } else if (this.addForm.rank == 3) {
        this.addForm.parentId = this.twoList[0].id + "";
      }
    },
    // 上传分类图片
    uploadSortImg(file) {
      if (file.length) {
        const formData = new FormData();
        formData.append("file", file[0]);
        this.$uploadRequest({
          method: "post",
          url: "admin/ashx/UploadImg.ashx?type=UploadFile&fileType=Navigation",
          data: formData,
        })
          .then((res) => {
            if (res.flag == 0) {
              this.addForm.icon = res.message;
              this.sortImg = this.$setImgUrl(res.message);
              this.$message.success("图片上传成功");
            } else {
              this.$message.error(res.message);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    /**提交新增分类 */
    submit() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let data = {
            entId: window.localStorage.getItem("entId"),
            Id: this.addForm.id,
            channel_id: this.addForm.channelId,
            icon_url: this.addForm.icon,
            link_url: "",
            nav_type: this.addForm.navType,
            name: this.addForm.name,
            parent_id: this.addForm.parentId,
            rank: this.addForm.rank,
            sort_id: this.addForm.sort,
            status: this.addForm.status,
            title: this.addForm.title,
          };
          this.$request({
            url: "Navigation/EditNavigation",
            method: "post",
            data: data,
          }).then((res) => {
            if (res.success) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.clearForm();
              this.handleRefresh();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.articleSort {
  width: 100%;
  height: 100%;
}
</style>
